module.exports = __webpack_public_path__ + "img/is-muted.5c94a57f.svg";